export const COMPANY_TYPE = ["la società semplice",
    "la società in nome collettivo (s.n.c.)",
    "la società in accomandita semplice (s.a.s.)",
    "la società per azioni (s.p.a.)",
    "la società a responsabilità limitata (s.r.l.)",
    "la società in accomandita per azioni (s.a.p.a.)",
    "le società cooperative",
    "le società di mutuo soccorso"
];